import { useRouter } from 'next/navigation'
import qs from 'qs'

import { useApis } from '@/legacy-src/contexts/api-context'
import { useCompanyBenefitsSearchParams } from '@/legacy-src/hooks/useCompanyBenefitsSearchParams'
import useServices from '@/legacy-src/hooks/useServices'
import useUser from '@/legacy-src/hooks/useUser'
import Toaster from '@/legacy-src/utilities/toaster'

const useCompanyBenefitsConfirmation = (slug: string) => {
  const { refreshUser } = useUser()
  const { api } = useApis()
  const router = useRouter()
  const { refreshPrivateServices } = useServices()

  const { activationLinkId, blinkClientId, token, email, code, sharedCode, policyCode } =
    useCompanyBenefitsSearchParams()

  const confirmCompany = async () => {
    try {
      await api.confirmCompany({
        slug,
        companyEmail: email,
        activationLinkId,
        blinkClientId,
        token,
        code,
        sharedCode,
        policyCode,
      })

      refreshUser()
      refreshPrivateServices()

      router.replace('/client/calendar')
      Toaster.success('component.toaster.employeeReactivated')
    } catch (e: any) {
      console.log(e)

      if (e.data.type === 'EMPLOYEE_VERIFICATION_PROBLEM') {
        Toaster.error('errors.employeeVerificationProblem')
      } else {
        Toaster.error('errors.defaultError')
      }
    }
  }

  const linkParams = qs.stringify({
    companyEmployee: {
      email,
      activationLinkId,
      blinkClientId,
      token,
      slug,
      code,
      sharedCode,
      policyCode,
    },
  })

  const loginAndConfirmCompany = () => {
    router.push(`/login?${linkParams}`)
  }

  const registerAndConfirmCompany = () => {
    router.push(`/register/employee?${linkParams}`)
  }

  return {
    confirmCompany,
    registerAndConfirmCompany,
    loginAndConfirmCompany,
  }
}

export default useCompanyBenefitsConfirmation
